import L from 'leaflet';

// Custom CRS matching the county's existing tile set (served from
// /map-tiles/realtor/{z}/{x}_{y}.jpg), extracted from the already-deployed
// nolosha_webmap project's Leaflet config. `project` swaps lat/lng into
// raw game (x,y) so components can pass real in-game coordinates directly
// as [x, y] Leaflet positions, e.g. <Marker position={[gameX, gameY]}>.
export const RanchCRS = L.extend({}, L.CRS, {
    projection: {
        project: (latlng) => L.point(latlng.lat, latlng.lng),
        unproject: (point) => L.latLng(point.x, point.y),
        bounds: L.bounds([-6800, 2700], [8216, -4900]),
    },
    transformation: new L.Transformation(1 / 16490, 2367 / 5446, -1 / 16490, 1352 / 5446),
    scale: (zoom) => 256 * Math.pow(2, zoom),
    zoom: (scale) => Math.log(scale / 256) / Math.LN2,
    distance: (a, b) => {
        const dx = a.lng - b.lng;
        const dy = a.lat - b.lat;
        return Math.sqrt(dx * dx + dy * dy);
    },
    infinite: false,
});

// Corners in [gameX, gameY] order (this CRS's project() maps lat->x, lng->y)
export const RANCH_MAP_BOUNDS = [
    [-6800, 2700],
    [8216, -4900],
];

export const RANCH_DEFAULT_CENTER = [708, -1100];

export const RANCH_TILE_URL = '/map-tiles/realtor/{z}/{x}_{y}.jpg';
export const RANCH_MIN_ZOOM = 1;
export const RANCH_MAX_ZOOM = 7;
